import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";

import KazaEkle, { KazaDuzenle } from "./pages/KazaEkle";
import KazalarListesi from "./pages/KazalarListesi";
import KazaDetay from "./pages/KazaDetay";
import Istatistikler from "./pages/Istatistikler";
import KazaTopluYukle from "./pages/KazaTopluYukle";
import PersonelYonetim from "./pages/PersonelYonetim";
import TopluPersonelYukle from "./pages/TopluPersonelYukle";
import AdminPage from "./pages/AdminPage";
import MailScheduler from "./pages/MailScheduler";

/**
 * Başlangıç yönlendirmesi:
 * - Önce "takip" iznini deneyip kaza-ekle'ye yollar.
 * - Değilse "giris" iznini deneyip kazalar-listesi'ne yollar.
 * - İkisi de yoksa güvenli varsayılan: kazalar-listesi.
 * Not: UI'da yetkisiz mesajların görünmemesi için bloklar display:none içinde.
 */
const StartRedirect = () => {
  return (
    <>
      {/* 1. Öncelik: takip izni varsa -> kaza-ekle */}
      <div style={{ display: "none" }}>
        <PrivateRoute izin="takip">
          <Navigate to="kaza-ekle" replace />
        </PrivateRoute>
      </div>

      {/* 2. Aksi halde: giris izni varsa -> kazalar-listesi */}
      <div style={{ display: "none" }}>
        <PrivateRoute izin="giris">
          <Navigate to="kazalar-listesi" replace />
        </PrivateRoute>
      </div>

      {/* 3. Fallback (her ihtimale karşı) */}
      <Navigate to="kazalar-listesi" replace />
    </>
  );
};

const Main = () => {
  return (
    <>
      <Navbar />
      <Routes>
        {/* İlk açılan sayfa */}
        <Route path="/" element={<StartRedirect />} />

        {/* Kaza ekleme: "takip" izni gerekir */}
        <Route
          path="kaza-ekle"
          element={
            <PrivateRoute izin="takip">
              <KazaEkle />
            </PrivateRoute>
          }
        />

        <Route path="kaza-duzenle/:id" element={<PrivateRoute izin="duzenle"><KazaDuzenle /></PrivateRoute>} />
        {/* Kazalar listesi: "giris" izni gerekir */}
        <Route
          path="kazalar-listesi"
          element={
            <PrivateRoute izin="giris">
              <KazalarListesi />
            </PrivateRoute>
          }
        />

        {/* Detay sayfası (gerekirse PrivateRoute ekleyebilirsin) */}
        <Route path="kaza-detay/:id" element={<KazaDetay />} />

        {/* İstatistikler: "giris" izni gerekir */}
        <Route
          path="istatistikler"
          element={
            <PrivateRoute izin="giris">
              <Istatistikler />
            </PrivateRoute>
          }
        />

        {/* Yükleme/Personel işlemleri: "takip" izni gerekir */}
        <Route
          path="kaza-toplu-yukle"
          element={
            <PrivateRoute izin="takip">
              <KazaTopluYukle />
            </PrivateRoute>
          }
        />
        <Route
          path="personel-yonetim"
          element={
            <PrivateRoute izin="takip">
              <PersonelYonetim />
            </PrivateRoute>
          }
        />
        <Route
          path="toplu-personel-yukle"
          element={
            <PrivateRoute izin="takip">
              <TopluPersonelYukle />
            </PrivateRoute>
          }
        />

        {/* Admin alanları: "olusturucu" izni gerekir */}
        <Route
          path="admin"
          element={
            <PrivateRoute izin="olusturucu">
              <AdminPage />
            </PrivateRoute>
          }
        />
        <Route
          path="mail-scheduler"
          element={
            <PrivateRoute izin="olusturucu">
              <MailScheduler />
            </PrivateRoute>
          }
        />

        {/* Tanımsız yollar için fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default Main;
